import type { ProblemScoringViewOption } from '~/@pages/@common/(ProblemScoring)/@trait/ProblemScoringViewOption.trait'

type ViewOption = ProblemScoringViewOption<'NOT_학습모듈'>

/**
 * 교재 detail 페이지에서 "정답이 비공개 되어있습니다." empty 화면 노출 여부.
 *
 * `hasCopyRight=true` 는 Mathflat 측에 정답·해설 데이터가 있는 콘텐츠
 * (시중교재/교과서/커스텀시그니처/학원그룹). `false` 는 내교재/시그니처처럼
 * 학생 본인이 만들거나 자체 콘텐츠라 학원 자유 노출이 가능한 케이스.
 *
 * - 학생: hasCopyRight 콘텐츠에서 학원이 정답공개를 닫아둔 채점전 일반채점
 *   + 학생이 한 문제도 안 풀었을 때 가린다. hasCopyRight=false 는 본문 노출.
 * - 학부모: hasCopyRight=true 콘텐츠에서 학부모정답해설공개(=studentAppSetting
 *   .채점후정답해설공개)가 꺼져 있으면 가린다. 그 외(hasCopyRight=false 또는
 *   학부모정답해설공개=true)는 본문 노출.
 */
export const shouldShowProblemListEmpty = ({
  viewOption,
  isNothingSubmitted,
}: {
  viewOption: ViewOption
  isNothingSubmitted: boolean
}): boolean => {
  if (viewOption.isParentView) {
    return (
      !!viewOption.hasCopyRight &&
      viewOption.studentAppSetting?.채점후정답해설공개 === false
    )
  }
  return !!viewOption.hasCopyRight && viewOption.채점불가능 && isNothingSubmitted
}
